var map = {
	"./addSpecialClass": 821,
	"./addSpecialClass.js": 821,
	"./addStartAndEnd": 822,
	"./addStartAndEnd.js": 822,
	"./removeLabelStyle": 823,
	"./removeLabelStyle.js": 823,
	"./removeStyleAndPoint": 824,
	"./removeStyleAndPoint.js": 824,
	"./storyLayout": 825,
	"./storyLayout.js": 825,
	"./storyLayout.png": 1109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4726;